import { useStores } from './useStores';

export const useSnackbar = () => {
  const { appStore } = useStores();

  const addSnackbar = (message: string) => {
    appStore.snackbarMessages = [...appStore.snackbarMessages, message];
  };

  return { addSnackbar };
};
